import { useEffect, useState } from 'react';
import supabase from '../config/supabaseClient';
import TestCard from '../components/TestCard';


const View_test = () => {
  const [view_test, setview_test] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [orderBy, setOrderBy] = useState('created_at');


  // Fetch talks from Supabase
  useEffect(() => {
    const fetchTalks = async () => {
      try {
        const { data, error } = await supabase
          .from('tests')
          .select('*')
          .order(orderBy, { ascending: false });


        if (error) throw error;
        setview_test(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTalks();
  }, [orderBy]); 

  // Handle delete action
  const handleDelete = (id) => {
    setview_test(prevTalks => prevTalks.filter(talk => talk.id !== id));
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p className="error">Error: {error}</p>;

  return (
    <div className="page home">
      <div className="order-by">
        <p>Order by:</p>
        <button onClick={() => setOrderBy('created_at')}>Time Created</button>
        <button onClick={() => setOrderBy('test_name')}>Test Name</button>
      </div>

      <div className="smoothie-grid">
        {
          view_test.length === 0 ? (
          <p>No records found.</p>
        ) : (
          view_test.map(talk => (
            <TestCard key={talk.id} talk={talk} onDelete={handleDelete} />
          ))
        )}
      </div>
    </div>
  );
};

export default View_test;
